export default {
  form: {
    address: {
      label: 'Morada',
      placeholder: 'Rua + número',
    },
    city: {
      label: 'Cidade',
      placeholder: 'Cidade',
    },
    state: {
      label: 'Distrito',
      placeholder: 'Selecionar distrito',
    },
    country: {
      label: 'País',
      placeholder: 'Selecionar país',
    },
    zip_code: {
      label: 'Código postal',
      placeholder: 'Código postal',
    },
  },
};
